import {
  JobsConfigurationCommand,
  JobsConfigurationJob
} from "modules/system/sections/plt/field-management/rings/rollout-package/configure/jobs/dtos";
import { useJobsFormOperations } from "modules/system/sections/plt/field-management/rings/rollout-package/configure/jobs/jobs.hooks";
import React, { useState } from "react";

import {
  DefaultButton,
  ScrollablePane,
  ScrollbarVisibility,
  Stack,
  Text,
  useTheme
} from "@bps/fluent-ui";
import { usePermissionsCheckQuery } from "@libs/api/gateways/env/env-gateway.hooks";
import {} from "@libs/api/gateways/field/field-ops-gateway.hooks";
import { NO_ACTION_PERMISSION } from "@libs/permissions/permissions.constants";
import { Permissions } from "@libs/permissions/permissions.enum";

import { CommandsFilter, CommandsFilterValues } from "./CommandsFilter";
import { CommandsTable } from "./CommandsTable";
import { CommandEditHost } from "./edit";

interface CommandsProps {
  job: JobsConfigurationJob;
}

export const Commands: React.FC<CommandsProps> = ({ job }) => {
  const theme = useTheme();
  const [showAdd, setShowAdd] = useState<boolean>(false);
  const [filterArgs, setFilterArgs] = useState<CommandsFilterValues>({
    name: ""
  });

  const { data: hasWritePermission } = usePermissionsCheckQuery(
    Permissions.PltFieldManagementWrite
  );

  const { addCommand } = useJobsFormOperations();

  return (
    <>
      <Stack verticalFill tokens={{ childrenGap: theme.spacing.s1 }}>
        <Stack horizontal horizontalAlign="space-between">
          <Text variant="xLarge">Commands</Text>

          <Stack.Item align="end">
            <DefaultButton
              iconProps={{ iconName: "Add" }}
              onClick={() => setShowAdd(true)}
              disabled={!hasWritePermission}
              title={!hasWritePermission ? NO_ACTION_PERMISSION : undefined}
            >
              Add Command
            </DefaultButton>
          </Stack.Item>
        </Stack>

        <ScrollablePane
          scrollbarVisibility={ScrollbarVisibility.auto}
          styles={{ root: { height: "100%", position: "relative" } }}
        >
          <CommandsFilter setFilterArgs={setFilterArgs} />
          <CommandsTable
            job={job}
            items={filterAndSortCommands(job.commands, filterArgs)}
          />
        </ScrollablePane>
      </Stack>
      <CommandEditHost
        modeLabel="Add"
        job={job}
        hidden={!showAdd}
        onDismiss={() => setShowAdd(false)}
        onUpdate={addCommand}
      />
    </>
  );
};

const filterAndSortCommands = (
  commands: JobsConfigurationCommand[] | undefined,
  filter: CommandsFilterValues
): JobsConfigurationCommand[] => {
  if (!commands) return [];

  return commands
    .filter(
      d =>
        filter.name === "" ||
        d.code.toLowerCase().indexOf(filter.name.toLowerCase()) >= 0 ||
        (d.commandName &&
          d.commandName.toLowerCase().indexOf(filter.name.toLowerCase()) >= 0)
    )
    .sort((a: JobsConfigurationCommand, b: JobsConfigurationCommand) => {
      return a.code < b.code ? -1 : 1;
    });
};
